/**
 * 紫導 — 課程順序報名閘門
 * 規則：初班 → 中班 → 高班 → 師傅班；預設只開放 Level 1。
 * 解鎖依據：已購買上一班「全班套餐」（Shopify 訂單），非看完影片。
 * 由 Liquid 注入 window.ZD_COURSE_PURCHASED = { ziwei, tarot }（已購最高級 0–4）
 */
(function (global) {
  'use strict';

  var LEVEL_NAMES = { 1: '初班', 2: '中班', 3: '高班', 4: '師傅班' };
  var PREV_NAMES = { 2: '初班', 3: '中班', 4: '高班' };

  var state = {
    /* 各軌道「當前可報」級別（1–4）= 已購最高級 + 1 */
    openLevel: { ziwei: 1, tarot: 1 },
    purchased: { ziwei: 0, tarot: 0 },
    ready: false
  };

  function clamp(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) return 1;
    if (n > 4) return 4;
    return n;
  }

  function clampPurchased(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) return 0;
    if (n > 4) return 4;
    return n;
  }

  function lockHint(level) {
    var prev = PREV_NAMES[level] || '上一班';
    return '須先購買「' + prev + '」全班套餐後，方可報讀此班。';
  }

  function openFromPurchased(purchasedLevel) {
    return clamp(clampPurchased(purchasedLevel) + 1);
  }

  function applyFromPurchasedMap(map) {
    if (!map || typeof map !== 'object') return;
    if (map.ziwei != null) {
      state.purchased.ziwei = clampPurchased(map.ziwei);
      state.openLevel.ziwei = openFromPurchased(state.purchased.ziwei);
    }
    if (map.tarot != null) {
      state.purchased.tarot = clampPurchased(map.tarot);
      state.openLevel.tarot = openFromPurchased(state.purchased.tarot);
    }
  }

  function applyCoursesPage() {
    var cards = document.querySelectorAll('.zdco-card[data-zd-level]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var track = card.getAttribute('data-zd-track') || 'ziwei';
      var level = parseInt(card.getAttribute('data-zd-level'), 10) || 1;
      var open = state.openLevel[track] || 1;

      card.classList.remove('is-enroll-locked', 'is-enroll-open');

      var group = card.querySelector('.zdco-card__btn-group');
      if (group && !group.querySelector('.zdco-card__cta--locked')) {
        var locked = document.createElement('div');
        locked.className = 'zdco-card__cta zdco-card__cta--full zdco-card__cta--locked';
        locked.setAttribute('aria-disabled', 'true');
        locked.innerHTML = '🔒 尚未解鎖';
        var hint = document.createElement('div');
        hint.className = 'zdco-card__lock-hint';
        hint.setAttribute('data-zd-lock-hint', '1');
        group.insertBefore(hint, group.firstChild);
        group.insertBefore(locked, hint.nextSibling);
      }

      var hintEl = card.querySelector('[data-zd-lock-hint]');
      if (hintEl) hintEl.textContent = lockHint(level);

      if (level > open) {
        card.classList.add('is-enroll-locked');
      } else if (level === open) {
        card.classList.add('is-enroll-open');
      }
    });

    document.querySelectorAll('.zdco-pathway').forEach(function (pathEl) {
      var open = Math.max(state.openLevel.ziwei || 1, state.openLevel.tarot || 1);
      pathEl.querySelectorAll('[data-zd-path-level]').forEach(function (step) {
        var lv = parseInt(step.getAttribute('data-zd-path-level'), 10);
        step.classList.remove('is-open', 'is-locked');
        if (lv === open) step.classList.add('is-open');
        else if (lv > open) step.classList.add('is-locked');
      });
    });
  }

  function applyDetailPage() {
    var root = document.querySelector('[data-zd-course-detail]');
    if (!root) return;

    var track = root.getAttribute('data-zd-track') || 'ziwei';
    var level = parseInt(root.getAttribute('data-zd-level'), 10) || 1;
    var open = state.openLevel[track] || 1;
    var locked = level > open;

    var banner = root.querySelector('[data-zd-gate-banner]');
    if (banner) {
      banner.style.display = locked ? 'block' : 'none';
      banner.textContent = locked
        ? ('⚠️ 必須按順序報名：' + lockHint(level))
        : '';
    }

    root.querySelectorAll('.zcd-hero__cta, .zcd-enroll-btn').forEach(function (el) {
      if (!locked) {
        el.classList.remove('zd-gate-disabled');
        if (el.dataset.zdHref) {
          el.setAttribute('href', el.dataset.zdHref);
          delete el.dataset.zdHref;
        }
        el.style.pointerEvents = '';
        el.style.opacity = '';
        return;
      }
      if (el.tagName === 'A' && el.getAttribute('href') && !el.dataset.zdHref) {
        el.dataset.zdHref = el.getAttribute('href');
        el.removeAttribute('href');
      }
      el.classList.add('zd-gate-disabled');
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.45';
      el.style.cursor = 'not-allowed';
      if (el.classList.contains('zcd-enroll-btn--full') || el.classList.contains('zcd-hero__cta')) {
        el.textContent = '🔒 須先購買' + (PREV_NAMES[level] || '上一班') + '後開放';
      }
    });
  }

  function applyProductPage() {
    var root = document.querySelector('[data-zd-product-gate]');
    if (!root) return;

    var track = root.getAttribute('data-zd-track') || 'ziwei';
    var level = parseInt(root.getAttribute('data-zd-level'), 10) || 1;
    var open = state.openLevel[track] || 1;
    var locked = level > open;

    var banner = root.querySelector('[data-zd-gate-banner]');
    if (banner) {
      banner.hidden = !locked;
      banner.textContent = locked
        ? ('⚠️ 必須按順序報名：' + lockHint(level))
        : '';
    }

    var form = document.getElementById('zdpr-atc-form') || root.querySelector('form[action*="/cart/add"]');
    var btns = root.querySelectorAll('.zdpr-atc-btn, .zdpr-buy-btn, .zdpr-buy-atc, button[type="submit"], .zdpr-sub-btn, a[href*="/products/"]');

    if (locked) {
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          alert(lockHint(level));
        }, true);
      }
      btns.forEach(function (b) {
        if (b.closest('.zdh-nav') || b.closest('.zdh-footer')) return;
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.45';
        b.setAttribute('aria-disabled', 'true');
        if (b.classList.contains('zdpr-buy-atc') || b.classList.contains('zdpr-atc-btn')) {
          b.disabled = true;
          b.textContent = '🔒 須先購買' + (PREV_NAMES[level] || '上一班');
        }
      });
    }
  }

  function applyAll() {
    applyCoursesPage();
    applyDetailPage();
    applyProductPage();
    state.ready = true;
    document.dispatchEvent(new CustomEvent('zd:course-gate-ready', { detail: state.openLevel }));
  }

  /** 手動設定「可報」級別：{ ziwei: 2, tarot: 1 } */
  function setProgress(map) {
    if (!map || typeof map !== 'object') return;
    if (map.ziwei) state.openLevel.ziwei = clamp(map.ziwei);
    if (map.tarot) state.openLevel.tarot = clamp(map.tarot);
    applyAll();
  }

  /** 設定已購最高級：{ ziwei: 1, tarot: 0 } → open = purchased + 1 */
  function setPurchased(map) {
    applyFromPurchasedMap(map);
    applyAll();
  }

  function initFromPage() {
    applyFromPurchasedMap(global.ZD_COURSE_PURCHASED);
    applyAll();
  }

  var api = {
    setProgress: setProgress,
    setPurchased: setPurchased,
    fetchProgress: function () {
      initFromPage();
      return Promise.resolve(state.openLevel);
    },
    apply: applyAll,
    getOpenLevel: function () { return { ziwei: state.openLevel.ziwei, tarot: state.openLevel.tarot }; },
    getPurchased: function () { return { ziwei: state.purchased.ziwei, tarot: state.purchased.tarot }; },
    LEVEL_NAMES: LEVEL_NAMES
  };

  global.ZDCourseGate = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromPage);
  } else {
    initFromPage();
  }
})(window);
